function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { getColor } from '../Theme/selectors';
import withTheme from '../Theme/withTheme';
import Cushion from '../Cushion';
import CrossIcon from '../Icons/Cross';
import Rectangle from '../Rectangle';
import Shadow from '../Shadow';
function PanelClose(_ref) {
  var backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    onClose = _ref.onClose,
    shadow = _ref.shadow,
    customStyle = _ref.style,
    uiTheme = _ref.uiTheme;
  return /*#__PURE__*/React.createElement(Cushion, {
    all: 9,
    component: "div",
    onClick: onClose,
    style: _objectSpread({
      position: 'absolute',
      top: 12,
      right: 12,
      zIndex: 999,
      cursor: 'pointer',
      lineHeight: 0
    }, customStyle)
  }, /*#__PURE__*/React.createElement(Shadow, {
    shadow: shadow || 'none'
  }, /*#__PURE__*/React.createElement(Cushion, {
    all: 9
  }, /*#__PURE__*/React.createElement(Rectangle, {
    component: "div",
    fill: backgroundColor,
    inline: true,
    radius: "50%"
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    color: getColor(uiTheme, color)
  })))));
}
PanelClose.defaultProps = {
  backgroundColor: 'transparent',
  color: 'black',
  onClose: function onClose() {
    return null;
  },
  shadow: null,
  style: {},
  uiTheme: null
};
export default withTheme(PanelClose);